var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-5"},[_c(_setup.ConsultantMissionsList,{attrs:{"missions":_setup.result?.myMissions?.data ?? [],"loading":_setup.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }